import { WantList } from './WantList';
export default WantList;
